import { render } from "./relieve_data.vue?vue&type=template&id=5c7e5270&scoped=true"
import script from "./relieve_data.vue?vue&type=script&lang=js"
export * from "./relieve_data.vue?vue&type=script&lang=js"

import "./relieve_data.vue?vue&type=style&index=0&id=5c7e5270&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7e5270"]])

export default __exports__